<template>
  <div
    class="player pa-3 d-flex align-center"
    :style="{backgroundColor: colors.bg}"
    :class="{flipped}"
  >
    <v-img
      :src="coin.image"
      :width="48"
      :transition="false"
      aspect-ratio="1"
      class="coin flex-grow-0" :class="flipped ? 'ml-n4' : 'mr-n4'"
    />
    <UserAvatar
      :user="user || {name: '?'}"
      round size="48" class="avatar" color="grey200"
      :class="flipped ? 'ml-3' : 'mr-3'"
    />
    <div class="text-ctn text-body-2">
      <Username
        v-if="user"
        :user="user"
        :style="{color: colors.text}"
      />
      <span v-else class="text--secondary text-caption">Empty slot</span>
      <h5 v-t="coin.name" class="text-caption text--secondary text-no-wrap lh-1-3" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coin: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    flipped: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colors() {
      const { coin, $vuetify } = this

      if (!this.user) {
        const { currentTheme: theme } = $vuetify.theme

        return {
          bg: theme.grey300,
          text: theme.grey100,
        }
      }

      return {
        bg: coin.colorBg,
        text: coin.colorText,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-ctn {
  overflow: hidden;
}

.flipped {
  justify-content: flex-end;

  .coin {
    order: 3;
  }

  .avatar {
    order: 2;
  }
}
</style>
